import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations de l'étudiant", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Numéro Matricule :", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Nom :", -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Prénom :", -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "Email :", -1)
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "Filière :", -1)
const _hoisted_19 = { key: 5 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "Niveau :", -1)
const _hoisted_21 = { key: 6 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "Année Académique :", -1)
const _hoisted_23 = { key: 7 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "Parent/Tuteur :", -1)
const _hoisted_25 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_26 = { style: {"max-width":"1200px","width":"100%","margin":"auto"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-3 text-center" }, "Pièces jointes", -1)
const _hoisted_28 = { class: "table table-bordered table-striped" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Numéro"),
    /*#__PURE__*/_createElementVNode("th", null, "Document")
  ])
], -1)
const _hoisted_30 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-inscriptions",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Retour ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_ctx.inscription?.etudiant?.numeroMatricule)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.etudiant?.numeroMatricule), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.etudiant?.nom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.etudiant?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.etudiant?.prenom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.etudiant?.prenom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.etudiant?.email)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.etudiant?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.filiere?.libelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.filiere?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.niveau?.libelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.niveau?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.annee?.libelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription?.annee?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.inscription?.etudiant?.parentetudiants?.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("td", null, _toDisplayString(_ctx.inscription.etudiant.parentetudiants[0].parent.nom) + " " + _toDisplayString(_ctx.inscription.etudiant.parentetudiants[0].parent.prenom), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.inscription?.etudiant?.pieces?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("table", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inscription.etudiant.pieces, (piece, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(piece.typePiece?.libelle), 1),
                          _createElementVNode("td", null, _toDisplayString(piece.numeroPiece), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: _ctx.getUrlApiForInscriptionsFiles(piece.urlImage),
                              target: "_blank",
                              class: "btn btn-sm btn-outline-primary"
                            }, " Voir ", 8, _hoisted_30)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}